jQuery(document).ready(function(){
    /**
     * jQuery function to detect browser type and add corresponding class to HTML element
     * Usage: Simply include this script after jQuery is loaded
     */
    (function($) {
        // Run when DOM is fully loaded
        $(document).ready(function() {
            // Function to detect browser and add class to HTML element
            function detectBrowserAndAddClass() {
                var browserClasses = [];
                var userAgent = navigator.userAgent.toLowerCase();
                
                // Detect browser types
                if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
                    browserClasses.push('browser-ie');
                } else if (userAgent.indexOf('edge') !== -1 || userAgent.indexOf('edg/') !== -1) {
                    browserClasses.push('browser-edge');
                } else if (userAgent.indexOf('firefox') !== -1) {
                    browserClasses.push('browser-firefox');
                } else if (userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1) {
                    browserClasses.push('browser-safari');
                } else if (userAgent.indexOf('chrome') !== -1) {
                    browserClasses.push('browser-chrome');
                    
                    // Check if it's Chrome or a Chromium-based browser
                    if (userAgent.indexOf('opr') !== -1 || userAgent.indexOf('opera') !== -1) {
                        browserClasses.push('browser-opera');
                    }
                }
                
                // Detect mobile/desktop
                if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
                    browserClasses.push('browser-mobile');
                } else {
                    browserClasses.push('browser-desktop');
                }
                
                // Add browser version for major browsers
                var version;
                if ((version = userAgent.match(/chrome\/(\d+)/)) !== null) {
                    browserClasses.push('chrome-' + version[1]);
                } else if ((version = userAgent.match(/firefox\/(\d+)/)) !== null) {
                    browserClasses.push('firefox-' + version[1]);
                } else if ((version = userAgent.match(/safari\/(\d+)/)) !== null && userAgent.indexOf('chrome') === -1) {
                    browserClasses.push('safari-' + version[1]);
                }
                
                // Add all classes to HTML element
                $('html').addClass(browserClasses.join(' '));
            }
            
            // Call the function
            detectBrowserAndAddClass();
        });
    })(jQuery);
});